// import React from 'react';
import AsyncSelect from 'react-select/async';
import { FaPlus, FaTrash, FaSearch } from 'react-icons/fa';

// Separate the styles and components for the AsyncSelect
const customStyles = {
  control: (provided) => ({ ...provided, minHeight: '31px', height: '31px', fontSize: '14px' }),
  option: (provided) => ({ ...provided, fontSize: '14px' }),
  singleValue: (provided) => ({ ...provided, fontSize: '14px' }),
  input: (provided) => ({ ...provided, margin: '0', padding: '0' }),
  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
};

const customComponents = {
  DropdownIndicator: () => <FaSearch className="mx-2" />,
  IndicatorSeparator: () => null,
};

const formatCandidateOption = (option) => {
  if (!option || !option.data) {
    return <div>Select a candidate...</div>;
  }
  const { candidateName } = option.data;
  return (
    <div>
      <div><strong>{candidateName || "Unknown"}</strong></div>
      {/* <div>Mobile: {mobile || "N/A"}</div>
      <div>Aadhar: {aadharNumber || "N/A"}</div>
      <div>Guardian: {guardianName || "N/A"}</div>  */}
    </div>
  );
};

export default function CandidateTable({
  candidates,
  candidateErrors,
  handleAddCandidate,
  handleDeleteCandidate,
  handleCandidateSelect,
  loadCandidateOptions,
}) {

  return (
    <div className="card mb-4">
      <div className="card-header d-flex justify-content-between align-items-center">
        <span><i className="fas fa-users me-1"></i> Candidate Details</span>
        <button
          type="button"
          className="btn btn-primary btn-sm"
          onClick={handleAddCandidate}
        >
          <FaPlus className="me-1" /> Add Candidate
        </button>
      </div>
      <div className="card-body">
        <div className="table-responsive">
          <table className="table table-bordered table-striped">
            <thead>
              <tr>
                <th>Sr. No</th>
                <th>Search & Select Candidate</th>
                <th>Name</th>
                <th>Mobile</th>
                <th>Aadhar</th>
                <th>Guardian Name</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {candidates.length > 0 ? (
                candidates.map((candidate, index) => (
                  <tr key={index}>
                    <td className="align-middle text-center">{index + 1}</td>
                    <td className="align-middle">
                      <AsyncSelect
                        className={`basic-single ${candidateErrors[index]?.candidateId ? 'is-invalid' : ''}`}
                        classNamePrefix="select"
                        cacheOptions
                        defaultOptions
                        loadOptions={loadCandidateOptions}
                        onChange={(selected) => handleCandidateSelect(index, selected)}
                        placeholder="Search ..."
                        formatOptionLabel={formatCandidateOption}
                        noOptionsMessage={() => "No candidates found"}
                        loadingMessage={() => "Loading..."}
                        isClearable={true}
                        value={candidate.selectOption || null}
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                        components={customComponents}
                        styles={customStyles}

                      // 🔹 Custom filter logic
                      // filterOption={(option, rawInput) => {
                      //   const search = rawInput.toLowerCase();
                      //   const { candidateName, mobile, aadharNumber } = option.data;

                      //   return (
                      //     candidateName?.toLowerCase().includes(search) ||
                      //     mobile?.toLowerCase().includes(search) ||
                      //     aadharNumber?.toLowerCase().includes(search)
                      //   );
                      // }}

                      />
                      {candidateErrors[index]?.candidateId && (
                        <div className="invalid-feedback d-block">
                          {candidateErrors[index].candidateId}
                        </div>
                      )}
                    </td>
                    <td className="align-middle">{candidate.candidateName}</td>
                    <td className="align-middle">{candidate.mobile}</td>
                    <td className="align-middle">{candidate.aadharNumber}</td>
                    <td className="align-middle">{candidate.guardianName}</td>
                    <td className="align-middle text-center">
                      <button
                        type="button"
                        className="btn btn-danger btn-sm"
                        onClick={() => handleDeleteCandidate(index)}
                      >
                        <FaTrash />
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7" className="text-center">No candidates added.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}